module.exports = __webpack_public_path__ + "img/closejdsmall.3a30424e.svg";